import React, { useState, useEffect, useRef } from "react";
import {
    Container,
    Grid,
    useTheme,
    Box,
} from "@mui/material";
import ImagePreview from "../components/FormsUI/PreviewImage/index";
import Controls from "../components/FormsUI";
import { useAuth } from "../utility/auth";
import { QRCodeCanvas } from "qrcode.react";
import WhatsAppController from "../controller/WhatsAppController";
import ExceptionHandlerController from "../controller/ErrorLogsController";
import Load from "../components/FormsUI/Loader/index";
import MastersController from "../controller/MastersController";
import CustomizedSnackbars from "../components/Alert";
import "../css/style.css";
import { tokens } from "../theme";

const ConnectWhatsApp = () => {
    const whatsAppController = new WhatsAppController();
    const exceptionHandlerController = new ExceptionHandlerController();
    const mastersController = new MastersController();
    const auth = useAuth();
    const user = auth.decoder(sessionStorage.getItem("user"));
    const { data, token } = user;
    // const { userid: tenantId } = data.UserInfo;
    const { userid: userId, tenantid: tenantId } = data.UserInfo;
    const [loader, setLoader] = useState(false);
    const [qrLoader, setQrLoader] = useState(false);
    const [alert, setAlert] = useState({ counter: 0, type: "", msg: "" });
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const [QRData, setQRData] = useState({});
    const [openQRPopUp, setOpenQRPopUp] = useState(false);
    const [loginData, setLoginData] = useState(null);

    // Refs to hold interval and timeout IDs
    const intervalRef = useRef(null);
    const timeoutRef = useRef(null);
    const stopTimeoutRef = useRef(null);

    const handleOpenPopup = () => setOpenQRPopUp(true);
    const handleClosePopup = () => {
        setOpenQRPopUp(false);
        clearInterval(intervalRef.current);
        clearTimeout(timeoutRef.current);
        clearTimeout(stopTimeoutRef.current);
    };

    const showAlert = (type, msg) => {
        setAlert(prev => ({
            counter: prev.counter + 1,
            type,
            msg,
        }));
    };

    useEffect(() => {
        fetchLoginData();
    }, []);

    const fetchLoginData = async () => {
        try {
            setLoader(true);
            const checkLoginStatusData = await whatsAppController.checkLoginStatus(userId, token);
            if (checkLoginStatusData?.status === 200 && checkLoginStatusData?.data?.success) {
                const { isLogin, mobileNumber, userId } = checkLoginStatusData.data.data;
                setLoginData({ loggedIn: isLogin, mobileNumber, userId });
            } else {
                setLoginData({ loggedIn: false });
            }
        } catch (error) {
            handleError(error, "fetchLoginData");
            setLoginData({ loggedIn: false });
        } finally {
            setLoader(false);
        }
    };


    const getQr = async () => {
        try {
            const response = await whatsAppController.getQr(userId, token);

            if (response?.data?.message === "WhatsApp is Login") {
                fetchLoginData();
                handleClosePopup();
                return showAlert("success", response?.data?.message);
            }

            setQRData(prev => ({
                ...prev,
                qr: response?.data?.data?.qrString,
            }));

        } catch (error) {
            handleError(error, 'getQr');
        }
    };

    const WhatsAppLogin = async () => {
        setQrLoader(true);
        handleOpenPopup();

        try {
            const response = await whatsAppController.whatsAppInit(userId, token);
            if (response?.data?.data) {
                setQRData(response?.data?.data);
                showAlert("success", response?.data?.data?.message);
            } else {
                setQRData(null);
            }
        } catch (error) {
            handleError(error, 'WhatsAppLogin');
        }
        setQrLoader(false);

        // Refresh QR once after 30 seconds
        timeoutRef.current = setTimeout(() => {
            getQr();
        }, 30000);

        // Then refresh every 30 seconds
        intervalRef.current = setInterval(() => {
            getQr();
        }, 30000);

        // Stop refreshing after 2 minutes (120 seconds)
        stopTimeoutRef.current = setTimeout(() => {
            clearInterval(intervalRef.current);
        }, 120000);
    };
    const handleError = (error, data) => {
        const logData = {
            message: error?.message,
            stack: error?.stack,
        };
        const logError = {
            logData,
            module: `ConnectionWhatsapp ${data}`,
        };
        exceptionHandlerController.HandleException(logError);
    };

    if (loader) return <Load />;

    return (
        <Box
            sx={{
                "& .formBg": {
                    border: `1px solid ${colors.grey[900]}`,
                    background: `${colors.primary[400]}`,
                },
                "& li.MuiBreadcrumbs-li h6": { color: `${colors.primary[200]}` },
                "& .MuiGrid-root.Mui-heading h2": {
                    color: `${colors.primary[200]} !important`,
                },
            }}
        >
            <Grid container>
                <Grid className="breadcrumb-section">
                    <Grid className="breadcrumb-container">
                        <Grid className="Mui-li">
                            <nav className="Mui-nav" aria-label="breadcrumb">
                                <ol className="">
                                    <li className="MuiBreadcrumbs-li">
                                        <h6 className="breadsub">Home</h6>
                                    </li>
                                    <li aria-hidden="true" className="MuiBreadcrumbs-separator">/</li>
                                    <li className="MuiBreadcrumbs-li">
                                        <h6>Connect WhatsApp</h6>
                                    </li>
                                </ol>
                            </nav>
                        </Grid>
                    </Grid>
                </Grid>

                <Grid item xs={12} md={12} className="adduser au1 pt-2">
                    <Controls.ActionButton onClick={WhatsAppLogin}>
                        {loginData?.loggedIn ? "Connected" : "Connect Your WhatsApp"}
                    </Controls.ActionButton>

                    <Container maxWidth="md" className="formClwidth">
                        <Controls.Popup
                            title="Scan QR Code to Connect WhatsApp"
                            minHeight={100}
                            openPopup={openQRPopUp}
                            setOpenPopup={handleClosePopup}
                        >
                            <div
                                style={{
                                    display: "flex",
                                    flexDirection: "column",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    padding: 20,
                                    background: "#fff",
                                    border: "1px solid #ccc",
                                    minHeight: 400,
                                }}
                            >
                                {!qrLoader ? (
                                    <>
                                        {QRData?.qr ? (
                                            <QRCodeCanvas value={QRData.qr} size={300} />
                                        ) : (
                                            <h2>
                                                {QRData?.message === 'Client ready'
                                                    ? "Your WhatsApp is already connected. You can start sending messages."
                                                    : 'Please try again after sometime'}
                                            </h2>
                                        )}
                                        {QRData?.qr && (
                                            <div style={{ marginTop: 20, textAlign: "center" }}>
                                                <p><strong>Instructions:</strong><br />
                                                    Open WhatsApp → Click 3 Dots → Linked Devices → Scan QR
                                                </p>
                                            </div>
                                        )}
                                    </>
                                ) : (
                                    <p style={{ color: "red" }}>Please wait while QR is generating</p>
                                )}
                            </div>
                        </Controls.Popup>
                    </Container>
                </Grid>
            </Grid>

            <div
                style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    paddingTop: '100px',
                    fontSize: '25px',
                }}
            >
                {loginData?.loggedIn ? (
                    <h3 style={{ color: "green" }}>
                        WhatsApp successfully connected to: +{loginData?.mobileNumber}
                    </h3>
                ) : (
                    <h3 style={{ color: 'red' }}>
                        Connect your WhatsApp
                    </h3>
                )}
            </div>

            {alert.counter > 0 && (
                <CustomizedSnackbars
                    status={alert.counter}
                    msg={alert.msg}
                    type={alert.type}
                />
            )}
        </Box>
    );
};

export default ConnectWhatsApp;
